export default __webpack_public_path__ + "static/media/transfer1.a4dee27a.mp4";